import React from "react";

const Tasks = () => {
  return (
    <div className="tasks page">
      <div className="page-container">
        <div className="page-header">
          <div className="page-title">Tasks</div>
        </div>
      </div>
    </div>
  );
};

export default Tasks;
